/** Prazos de resposta e Modo Ponte da loja. */
import type { ConfigAtendimento, ConfigSla } from "@ydchat/shared";
import { CONFIG_SLA_PADRAO } from "@ydchat/shared";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, ErroApi } from "./api";

type Resposta = ConfigAtendimento & { iaDisponivel: boolean };
const chave = ["config-atendimento"];

export function useConfigAtendimento() {
  return useQuery({
    queryKey: chave,
    queryFn: () => api.get<Resposta>("/equipe/atendimento"),
    staleTime: 5 * 60_000,
  });
}

/** Limites dos níveis de espera (padrão enquanto carrega). */
export function useLimitesEspera(): ConfigSla {
  return useConfigAtendimento().data?.sla ?? CONFIG_SLA_PADRAO;
}

export function useSalvarConfigAtendimento() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (c: ConfigAtendimento) => api.put<Resposta>("/equipe/atendimento", c),
    onSuccess: (r) => {
      qc.setQueryData(chave, r);
      toast.success("Regras de atendimento salvas!");
    },
    onError: (e) => toast.error(e instanceof ErroApi ? e.message : "Não foi possível salvar."),
  });
}

export function useAcoesPonte(conversaId: string) {
  const qc = useQueryClient();
  const depois = () => void qc.invalidateQueries({ queryKey: ["conversa", conversaId] });
  const erro = (e: unknown) => toast.error(e instanceof ErroApi ? e.message : "Não foi possível.");
  return {
    assumir: useMutation({
      mutationFn: () => api.post(`/conversas/${conversaId}/ponte/assumir`),
      onSuccess: depois,
      onError: erro,
    }),
    ligar: useMutation({
      mutationFn: () => api.post(`/conversas/${conversaId}/ponte/ligar`),
      onSuccess: () => {
        depois();
        toast.success("Modo Ponte ligado nesta conversa.");
      },
      onError: erro,
    }),
  };
}
